exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DestinationPopup__container___NeTSH {\n  width: 320px;\n  border-radius: 5px;\n  box-shadow: 2px 2px 10px 0 rgba(157, 169, 182, 0.2);\n  border: solid 1px #dde5ed;\n  background-color: white;\n}\n\n.DestinationPopup__titleContainer___3ktjX {\n  color: #1e2535;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 20px 0 0 20px;\n}\n\n.DestinationPopup__addressContainer___Pt1Ah {\n  color: #5d7186;\n  font-size: 14px;\n  padding: 10px 20px 20px 20px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "DestinationPopup__container___NeTSH",
	"titleContainer": "DestinationPopup__titleContainer___3ktjX",
	"addressContainer": "DestinationPopup__addressContainer___Pt1Ah"
};